module.exports = __webpack_public_path__ + "static/front-bd6a991813678a79f14dc5a61776b8ed.svg";